<template>
	<div class="font-selection menu-item-picker">
		<v-select
			v-model="currentFontSize"
			item-text="itemText"
			item-value="itemValue"
			:items="fontSizes"
			outlined
			dense
			hide-details
			solo
		></v-select>
	</div>
</template>

<script>
import TiptapService from '../../tiptap-service';

const defaultSize = '14px';
const getItem = (textSize) => ({ itemText: textSize, itemValue: textSize + 'px' });

export default {
	name: 'FontSizeFormatting',
	props: {
		editor: { type: Object },
		selectionObj: { type: Object },
	},
	watch: {
		currentFontSize: {
			handler(newV) {
				if (newV) {
					this.editor.chain().focus().setFontSize(newV);
				}
			},
		},
		selectionObj: {
			handler(newV) {
				if (newV) {
					const fontSize = TiptapService.getFontSize(this.editor);
					this.currentFontSize =
						fontSize === 'contains_more_than_one_style' ? undefined : TiptapService.getFontSize(this.editor) || defaultSize;
				}
			},
		},
	},
	data() {
		return {
			fontSizes: Array.from({ length: 10 }, (_, i) => i + 8).map((i) => getItem(i)),
			currentFontSize: null,
		};
	},
};
</script>

<style lang="scss" scoped>
.font-selection {
	::v-deep {
		.v-input {
			max-width: 40px;
			font-size: 12px;
		}
		fieldset {
			border: 0 !important;
			background: transparent;
		}
		.v-select__selection {
			margin: 0 !important;
		}
		.v-input__slot {
			background: transparent !important;
			box-shadow: none !important;
		}
		.v-input__append-inner {
			display: none;
		}
	}
}
</style>
